import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vhsgogpurbvjjkurzzfp.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZoc2dvZ3B1cmJ2amprdXJ6emZwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYyNDg2OTcsImV4cCI6MjA2MTgyNDY5N30.QsNgn8ye80c_IFH7PHGxn4GHEtlL_UwEt80lAksb4ok';

export const supabase = createClient(supabaseUrl, supabaseKey); 